// eslint-disable-next-line no-restricted-imports
import { PositionResource, useOpenPositionsCommon } from '@eih-netbroker/common';
import { useMemo } from 'react';
import { Config } from '../../../../shared/config/config';
import { useEStream } from '../../../../shared/services/sse/useEStream';
import { useInstrumentSearch } from '../../../../shared/services/useInstrumentSearch';
import { useResource, useResourceHeaders } from '../../../../shared/services/useResource';
import { useLogger } from '../../../../shared/utils/useLogger';

export const useOpenPositions = () => {
  const { getResourceHeaderWithToken, getResourceHeaderForMultiAccount } = useResourceHeaders();
  const logger = useLogger(`useOpenPositions`);
  const { loadInstrument, getExchangeRate } = useEStream();
  const { getListedInstrumentList } = useInstrumentSearch();
  const positionResource = useResource(PositionResource);

  const p = useMemo(
    () => ({
      config: Config,
      logger,
      getResourceHeaderWithToken,
      getResourceHeaderForMultiAccount,
      loadInstrument,
      getExchangeRate,
      getListedInstrumentList,
      positionResource,
    }),
    [
      logger,
      getResourceHeaderWithToken,
      getResourceHeaderForMultiAccount,
      loadInstrument,
      getExchangeRate,
      getListedInstrumentList,
      positionResource,
    ],
  );

  return useOpenPositionsCommon(p);
};
